// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import axios from "axios";
// import { CONSTANTS } from "../constants/Constants";
// import {
//   getRecordedSessions,
//   getSubjects,
//   filterRecordedSessions,
// } from "../services/recordedSessionsService";
// import { useEnrollment } from "../context/EnrollmentContext";
// import LockedSection from "../components/LockedSection";

// const OnlineClassesPage = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   // State for filters and active tab
//   const [activeTab, setActiveTab] = useState("live");
//   const [subjectFilter, setSubjectFilter] = useState("all");
//   const [typeFilter, setTypeFilter] = useState("all");
//   const [searchQuery, setSearchQuery] = useState("");
//   const { activeEnrollments, loading: enrollmentLoading } = useEnrollment();

//   // State for API data
//   const [liveClasses, setLiveClasses] = useState([]);
//   const [recordedSessions, setRecordedSessions] = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedCourseId, setSelectedCourseId] = useState("all");
//   const [selectedLanguage, setSelectedLanguage] = useState("all");
//   const [selectedClass, setSelectedClass] = useState("10th");
//   const [classFilter, setClassFilter] = useState("all");
//   const [languageFilter, setLanguageFilter] = useState("all");

//   // Update the recorded sessions fetch useEffect
//   useEffect(() => {
//     const fetchRecordedSessions = async () => {
//       try {
//         setLoading(true);

//         // Build filters object with enrollment-based parameters
//         const filters = {
//           subject: subjectFilter,
//           type: typeFilter,
//           searchQuery: searchQuery,
//           class: selectedClass,
//           language: selectedLanguage,
//           courseid: selectedCourseId,
//         };

//         const sessionsData = await getRecordedSessions(filters);

//         // Handle new API response format
//         if (sessionsData.success) {
//           setRecordedSessions(sessionsData.recordedSessions);
//         } else {
//           setRecordedSessions(sessionsData);
//         }

//         // Get all subjects for filter dropdown
//         const subjectsData = await getSubjects();

//         if (subjectsData.success) {
//           setSubjects(subjectsData.subjects);
//         } else {
//           setSubjects(subjectsData);
//         }

//         setLoading(false);
//       } catch (err) {
//         console.error("Error fetching recorded sessions:", err);
//         setError("Failed to load recorded sessions. Please try again later.");
//         setLoading(false);
//         setRecordedSessions(mockRecordedClasses);
//       }
//     };

//     if (activeTab === "recorded") {
//       fetchRecordedSessions();
//     }
//   }, [activeTab, selectedCourseId, selectedLanguage, selectedClass]);

//   // Update the filter application useEffect dependencies
//   useEffect(() => {
//     const applyFilters = async () => {
//       if (activeTab !== "recorded") return;

//       try {
//         setLoading(true);

//         const filters = {
//           subject: subjectFilter,
//           type: typeFilter,
//           searchQuery: searchQuery,
//           class: selectedClass,
//           language: selectedLanguage,
//           courseid: selectedCourseId,
//         };

//         const filteredData = await filterRecordedSessions(filters);

//         if (filteredData.success) {
//           setRecordedSessions(filteredData.recordedSessions);
//         } else {
//           setRecordedSessions(filteredData);
//         }

//         setLoading(false);
//       } catch (err) {
//         console.error("Error filtering recorded sessions:", err);
//         setError("Failed to filter sessions. Please try again.");
//         setLoading(false);
//       }
//     };

//     if (activeTab === "recorded") {
//       applyFilters();
//     }
//   }, [
//     activeTab,
//     subjectFilter,
//     typeFilter,
//     searchQuery,
//     selectedCourseId,
//     selectedLanguage,
//     selectedClass,
//   ]);

//   // Handler for enrollment card selection
//   const handleEnrollmentSelect = (enrollment) => {
//     setSelectedCourseId(enrollment.courseId);
//     setSelectedLanguage(enrollment.language?.toLowerCase() || "all");

//     // Extract class from course name (you can adjust this logic based on your course naming)
//     const className = enrollment.courseName.includes("10th")
//       ? "10th"
//       : enrollment.courseName.includes("9th")
//       ? "9th"
//       : enrollment.courseName.includes("8th")
//       ? "8th"
//       : "all";
//     setSelectedClass(className);
//   };
//   useEffect(() => {
//     if (activeEnrollments && activeEnrollments?.length > 0) {
//       handleEnrollmentSelect(activeEnrollments[0]);
//     }
//   }, [activeEnrollments]);
//   const EnrollmentCards = () => {
//     if (enrollmentLoading) {
//       return (
//         <div className="text-center py-4">Loading your enrollments...</div>
//       );
//     }

//     if (activeEnrollments.length === 0) {
//       return (
//         <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-6">
//           <div className="flex">
//             <div className="flex-shrink-0">
//               <svg
//                 className="h-5 w-5 text-yellow-400"
//                 viewBox="0 0 20 20"
//                 fill="currentColor"
//               >
//                 <path
//                   fillRule="evenodd"
//                   d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
//                   clipRule="evenodd"
//                 />
//               </svg>
//             </div>
//             <div className="ml-3">
//               <h3 className="text-sm font-medium text-yellow-800">
//                 No Active Enrollments
//               </h3>
//               <p className="mt-1 text-sm text-yellow-700">
//                 You need to enroll in a course to access recorded sessions.
//                 <Link to="/classroom" className="font-medium underline ml-1">
//                   Browse courses
//                 </Link>
//               </p>
//             </div>
//           </div>
//         </div>
//       );
//     }
//   };
//   // Fetch live classes from API
//   useEffect(() => {
//     const fetchLiveClasses = async () => {
//       try {
//         setLoading(true);

//         // Get all classes (no authentication required)
//         const response = await axios.get(
//           `${CONSTANTS.APIURL}/api/scheduled-classesnew/public`
//         );
//         const classes = response.data || [];

//         // Transform the data
//         const formattedClasses = classes.map((cls) => ({
//           id: cls._id,
//           title: cls.title,
//           instructor: cls.instructor?.name || "Unknown Instructor",
//           date: formatDate(cls.scheduledStartTime),
//           time: `${formatTime(cls.scheduledStartTime)} - ${formatTime(
//             cls.scheduledEndTime
//           )}`,
//           subject: cls.category || "General",
//           description: cls.description,
//           image:
//             cls.thumbnail ||
//             "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRCjwItGdnaofbsuvTl7O9aJxfCBaZd-ms0lw&s",
//           joinLink: `/live-class/${cls._id}/join`,
//           status: getClassStatus(cls),
//           // No concept of enrollment now - all students can join
//           isEnrolled: true,
//           meetingId: cls.meetingId,
//           rawData: cls,
//         }));

//         setLiveClasses(formattedClasses);
//         setLoading(false);
//       } catch (err) {
//         console.error("Error fetching live classes:", err);
//         setError("Failed to load classes. Please try again later.");
//         setLoading(false);

//         // Fallback to mock data if API fails
//         setLiveClasses(mockLiveClasses);
//       }
//     };

//     fetchLiveClasses();
//   }, []);

//   // Helper function to format date
//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     const today = new Date();

//     if (date.toDateString() === today.toDateString()) {
//       return "Today";
//     }

//     return date.toLocaleDateString("en-US", {
//       month: "long",
//       day: "numeric",
//       year: "numeric",
//     });
//   };

//   // Helper function to format time
//   const formatTime = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleTimeString("en-US", {
//       hour: "numeric",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   // Helper function to determine class status
//   const getClassStatus = (cls) => {
//     if (cls.status === "live") {
//       return "live";
//     }

//     const now = new Date();
//     const startTime = new Date(cls.scheduledStartTime);
//     const endTime = new Date(cls.scheduledEndTime);

//     if (now < startTime) {
//       return "upcoming";
//     } else if (now > endTime || cls.status === "completed") {
//       return "completed";
//     } else {
//       return "live";
//     }
//   };

//   // Handle class enrollment
//   const handleEnroll = async (classId) => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem("token");
//       await axios.post(
//         `${CONSTANTS.APIURL}/api/scheduled-classes/${classId}/enroll`,
//         {},
//         {
//           headers: {
//             "Content-Type": "application/json",
//             "x-auth-token": token,
//           },
//         }
//       );

//       // Update class in state to show as enrolled
//       setLiveClasses((prevClasses) =>
//         prevClasses.map((cls) =>
//           cls.id === classId ? { ...cls, isEnrolled: true } : cls
//         )
//       );

//       setLoading(false);
//       alert("Successfully enrolled in class!");
//     } catch (err) {
//       console.error("Error enrolling in class:", err);
//       setLoading(false);
//       alert("Failed to enroll in class. Please try again.");
//     }
//   };

//   // Handle joining a class
//   const handleJoinClass = (classItem) => {
//     if (classItem.status === "live") {
//       navigate(`/live-class/${classItem.id}/join`);
//     } else if (classItem.status === "upcoming") {
//       alert(
//         "This class hasn't started yet. Please check back at the scheduled time."
//       );
//     } else {
//       alert(
//         "This class has ended. You can find the recording in the Recorded Classes section."
//       );
//     }
//   };

//   // Navigate to watch recorded session
//   const handleWatchRecordedSession = (sessionId) => {
//     navigate(`/watch-session/${sessionId}`);
//   };

//   // Mock data for live classes (fallback if API fails)
//   const mockLiveClasses = [
//     {
//       id: 1,
//       title: "Nagaland History - Pre-Colonial Period",
//       instructor: "Dr. Imtisunep Longchar",
//       date: "March 26, 2025",
//       time: "6:00 PM - 8:00 PM",
//       subject: "History",
//       description:
//         "Comprehensive coverage of Nagaland's pre-colonial history including tribal migrations, social structures, and cultural evolution.",
//       image:
//         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRCjwItGdnaofbsuvTl7O9aJxfCBaZd-ms0lw&s",
//       joinLink: "/join-class/1",
//       status: "upcoming",
//       isEnrolled: true,
//     },
//     {
//       id: 2,
//       title: "Nagaland Constitution & Polity",
//       instructor: "Prof. Kezhokhoto Savi",
//       date: "March 28, 2025",
//       time: "5:30 PM - 7:30 PM",
//       subject: "Polity",
//       description:
//         "Deep dive into Article 371A, special provisions for Nagaland, and the relationship between traditional and modern governance structures.",
//       image:
//         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHt7AhiWOTinHRunO000ZnWtuLGRFgmfzYLg&s",
//       joinLink: "/join-class/2",
//       status: "upcoming",
//       isEnrolled: false,
//     },
//     {
//       id: 3,
//       title: "Economic Development of Nagaland",
//       instructor: "Dr. Rosemary Dzüvichü",
//       date: "Today",
//       time: "7:00 PM - 9:00 PM",
//       subject: "Economy",
//       description:
//         "Analysis of Nagaland's economy, development challenges, and opportunities in the context of NPSC examination.",
//       image:
//         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTXQl0Y3ex2gY0XAg_Gs53z9geJ5Oj8eqInw&s",
//       joinLink: "/join-class/3",
//       status: "live",
//       isEnrolled: true,
//     },
//     {
//       id: 4,
//       title: "Geography of Northeast India",
//       instructor: "Prof. Ketholenuo Mer",
//       date: "March 24, 2025",
//       time: "6:00 PM - 8:00 PM",
//       subject: "Geography",
//       description:
//         "Understanding the geographical features, climate patterns, and natural resources of Northeast India with special focus on Nagaland.",
//       image:
//         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDpNOmnor84sA6cF9eoYfHPiz1SrplycxFyA&s",
//       joinLink: "/join-class/4",
//       status: "completed",
//       isEnrolled: true,
//     },
//   ];

//   // Mock data for recorded classes (fallback if API fails)
//   const mockRecordedClasses = [
//     {
//       id: 1,
//       title: "Nagaland State Formation",
//       instructor: "Dr. Imtisunep Longchar",
//       duration: "2h 15m",
//       date: "March 10, 2025",
//       subject: "History",
//       description:
//         "Detailed analysis of the events leading to the formation of Nagaland state, including the role of Naga National Council and the 16-Point Agreement.",
//       image:
//         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRl7riGHuxwQO0GevJa2YZqERjbYDXIC73agg&s",
//       watchLink: "/watch-class/1",
//       type: "foundation",
//     },
//     {
//       id: 2,
//       title: "Administrative Structure of Nagaland",
//       instructor: "Prof. Kezhokhoto Savi",
//       duration: "1h 45m",
//       date: "March 5, 2025",
//       subject: "Administration",
//       description:
//         "Comprehensive overview of Nagaland's administrative setup, roles of Deputy Commissioners, and the dual system of administration.",
//       image:
//         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSUOUbclaiPfI3EHLeftRlGUG1TNq1dVGBh1A&s",
//       watchLink: "/watch-class/2",
//       type: "mains",
//     },
//     // Additional mock data omitted for brevity
//   ];

//   if(activeEnrollments?.length === 0) {
//     return(
//       <LockedSection/>
//     )
//   }
//   return (
//     <div className="pt-20">
//       {/* Hero Section */}
//       <section className="relative bg-gray-900 text-white">
//         <div className="absolute inset-0">
//           <div className="absolute inset-0 bg-gray-900 opacity-90"></div>
//           <div className="absolute inset-0 bg-[url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRiqn5jXhC1CTq8isbIwTTte77VL0U7zhlBwQ&s')] opacity-10 bg-cover bg-center"></div>
//         </div>

//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
//           <div className="grid lg:grid-cols-12 gap-8 items-center">
//             {/* Left Content */}
//             <div className="lg:col-span-7">
//               <motion.h1
//                 className="text-4xl md:text-5xl font-extrabold tracking-tight mb-6"
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5 }}
//               >
//                 Excellence in Education
//               </motion.h1>
//               <motion.p
//                 className="text-lg md:text-xl mb-8 text-gray-200"
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5, delay: 0.1 }}
//               >
//                 Empowering students with comprehensive education for academic
//                 excellence and competitive exam success. Learn from top
//                 educators and subject matter experts from anywhere, anytime.
//               </motion.p>
              // <motion.div
              //   className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
              //   initial={{ opacity: 0, y: 20 }}
              //   animate={{ opacity: 1, y: 0 }}
              //   transition={{ duration: 0.5, delay: 0.2 }}
              // >
              //   <Link
              //     to="/classroom"
              //     className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-indigo-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
              //   >
              //     Subscribe Now
              //   </Link>
              //   <Link
              //     to="/watch-session/683ef9a271bed98aea1797e6"
              //     className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
              //   >
              //     Try Free Class
              //   </Link>
              // </motion.div>
//             </div>

//             {/* Right Content - Enrollment Cards */}
//             <div className="lg:col-span-5">
//               <motion.div
//                 className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10"
//                 initial={{ opacity: 0, x: 20 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 transition={{ duration: 0.6, delay: 0.3 }}
//               >
//                 <h3 className="text-xl font-semibold mb-6 text-yellow-400">
//                   Your Active Courses
//                 </h3>

//                 <div className="space-y-3 max-h-96 overflow-y-auto custom-scrollbar">
//                   {activeEnrollments.map((enrollment, index) => (
//                     <motion.div
//                       key={enrollment.courseId}
//                       onClick={() => handleEnrollmentSelect(enrollment)}
//                       className={`cursor-pointer border rounded-xl p-4 transition-all duration-200 hover:scale-[1.02] ${
//                         selectedCourseId === enrollment.courseId
//                           ? "border-yellow-400 bg-yellow-400/10"
//                           : "border-white/20 hover:border-white/40 bg-white/5"
//                       }`}
//                       initial={{ opacity: 0, y: 10 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.4, delay: 0.4 + index * 0.1 }}
//                     >
//                       <div className="flex items-center justify-between">
//                         <div className="flex-1 min-w-0">
//                           <h4 className="font-medium text-white text-sm truncate mb-2">
//                             {enrollment.courseName}
//                           </h4>
//                           <div className="space-y-1">
//                             <div className="flex items-center text-xs text-gray-300">
//                               <svg
//                                 className="w-3 h-3 mr-1"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 viewBox="0 0 24 24"
//                               >
//                                 <path
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                   strokeWidth={2}
//                                   d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
//                                 />
//                               </svg>
//                               {enrollment.language}
//                             </div>
//                             <div className="flex items-center justify-between">
//                               <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-500/20 text-green-300 border border-green-500/30">
//                                 Active
//                               </span>
//                               <span className="text-xs text-gray-400">
//                                 Expires:{" "}
//                                 {enrollment.expiryDate.toLocaleDateString(
//                                   "en-US",
//                                   {
//                                     month: "short",
//                                     day: "numeric",
//                                   }
//                                 )}
//                               </span>
//                             </div>
//                           </div>
//                         </div>

//                         {/* Selection indicator */}
//                         <div
//                           className={`ml-3 w-5 h-5 rounded-full border-2 transition-all duration-200 flex items-center justify-center ${
//                             selectedCourseId === enrollment.courseId
//                               ? "bg-yellow-400 border-yellow-400"
//                               : "border-white/40"
//                           }`}
//                         >
//                           {selectedCourseId === enrollment.courseId && (
//                             <svg
//                               className="w-3 h-3 text-gray-900"
//                               fill="currentColor"
//                               viewBox="0 0 20 20"
//                             >
//                               <path
//                                 fillRule="evenodd"
//                                 d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
//                                 clipRule="evenodd"
//                               />
//                             </svg>
//                           )}
//                         </div>
//                       </div>
//                     </motion.div>
//                   ))}
//                 </div>

//                 {/* No enrollments state */}
//                 {activeEnrollments.length === 0 && (
//                   <div className="text-center py-8">
//                     <svg
//                       className="w-12 h-12 text-gray-400 mx-auto mb-3"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={1}
//                         d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
//                       />
//                     </svg>
//                     <p className="text-sm text-gray-400">
//                       No active enrollments
//                     </p>
//                   </div>
//                 )}

//                 {/* Quick action button */}
//               </motion.div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Main Content */}
//       <section className="py-16 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           {/* Tabs */}
//           <div className="border-b border-gray-200 mb-8">
//             <div className="flex space-x-8">
//               <button
//                 className={`pb-4 text-lg font-medium ${
//                   activeTab === "live"
//                     ? "border-b-2 border-indigo-600 text-indigo-600"
//                     : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                 }`}
//                 onClick={() => setActiveTab("live")}
//               >
//                 Live Classes 👉
//               </button>
//               <button
//                 className={`pb-4 text-lg font-medium ${
//                   activeTab === "recorded"
//                     ? "border-b-2 border-indigo-600 text-indigo-600"
//                     : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                 }`}
//                 onClick={() => setActiveTab("recorded")}
//               >
//                 Recorded Classes 👉
//               </button>
//             </div>
//           </div>
//           {/* Live Classes Tab Content - Keeping this part same as before */}
//           {activeTab === "live" && (
//             <div>
//               {/* Live Classes content - same as before */}
//               <div className="mb-12">
//                 <h2 className="text-3xl font-bold text-gray-900 mb-6">
//                   Upcoming & Live Classes
//                 </h2>
//                 <p className="text-lg text-gray-600 mb-8">
//                   Join our expert instructors in real-time interactive sessions.
//                   Participate in discussions, ask questions, and get instant
//                   clarification on complex topics.
//                 </p>

//                 {loading ? (
//                   <div className="flex justify-center items-center py-20">
//                     <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
//                   </div>
//                 ) : error ? (
//                   <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
//                     {error}
//                   </div>
//                 ) : (
//                   <>
//                     {/* Currently Live Class - same as before */}
//                     {/* Upcoming Classes - same as before */}
//                     {/* Recent Completed Classes - same as before */}
//                     {liveClasses.filter((cls) => cls.status === "live").length >
//                       0 && (
//                       <div className="mb-12">
//                         <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
//                           <span className="relative flex h-3 w-3 mr-2">
//                             <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
//                             <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
//                           </span>
//                           Currently Live
//                         </h3>
//                         <div className="grid grid-cols-1 gap-6">
//                           {liveClasses
//                             .filter((cls) => cls.status === "live")
//                             .map((liveClass) => (
//                               <div
//                                 key={liveClass.id}
//                                 className="bg-gradient-to-r from-indigo-50 to-blue-50 border border-indigo-100 rounded-lg shadow-md overflow-hidden"
//                               >
//                                 <div className="flex flex-col md:flex-row">
//                                   <div className="md:w-1/3 bg-gray-200 h-60 md:h-auto">
//                                     <div className="w-full h-full bg-gray-300 flex items-center justify-center">
//                                       <img
//                                         src={
//                                           liveClass.image ||
//                                           "/images/placeholder.jpg"
//                                         }
//                                         alt={liveClass.title}
//                                         className="w-full h-full object-cover"
//                                       />
//                                     </div>
//                                   </div>
//                                   <div className="p-6 md:w-2/3 flex flex-col justify-between">
//                                     <div>
//                                       <div className="flex justify-between items-start">
//                                         <div>
//                                           <span className="inline-block bg-red-100 text-red-800 text-xs font-semibold px-2.5 py-0.5 rounded-md mb-2">
//                                             LIVE NOW
//                                           </span>
//                                           <h3 className="text-xl font-bold text-gray-900 mb-2">
//                                             {liveClass.title}
//                                           </h3>
//                                         </div>
//                                         <span className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-0.5 rounded">
//                                           {liveClass.subject}
//                                         </span>
//                                       </div>
//                                       <p className="text-gray-600 mb-4">
//                                         {liveClass.description}
//                                       </p>
//                                       <div className="flex flex-wrap gap-3 mb-4">
//                                         <div className="flex items-center text-sm text-gray-700">
//                                           <svg
//                                             className="w-4 h-4 mr-1 text-gray-600"
//                                             fill="none"
//                                             stroke="currentColor"
//                                             viewBox="0 0 24 24"
//                                           >
//                                             <path
//                                               strokeLinecap="round"
//                                               strokeLinejoin="round"
//                                               strokeWidth={2}
//                                               d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                                             />
//                                           </svg>
//                                           {liveClass.instructor}
//                                         </div>
//                                         <div className="flex items-center text-sm text-gray-700">
//                                           <svg
//                                             className="w-4 h-4 mr-1 text-gray-600"
//                                             fill="none"
//                                             stroke="currentColor"
//                                             viewBox="0 0 24 24"
//                                           >
//                                             <path
//                                               strokeLinecap="round"
//                                               strokeLinejoin="round"
//                                               strokeWidth={2}
//                                               d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                                             />
//                                           </svg>
//                                           {liveClass.time}
//                                         </div>
//                                       </div>
//                                     </div>
//                                     <div className="mt-4">
//                                       {liveClass.isEnrolled ? (
//                                         <button
//                                           onClick={() =>
//                                             handleJoinClass(liveClass)
//                                           }
//                                           className="inline-flex items-center justify-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-md transition-colors duration-300"
//                                         >
//                                           Join Now
//                                         </button>
//                                       ) : (
//                                         <button
//                                           onClick={() =>
//                                             handleEnroll(liveClass.id)
//                                           }
//                                           className="inline-flex items-center justify-center px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-md transition-colors duration-300"
//                                         >
//                                           Enroll & Join
//                                         </button>
//                                       )}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             ))}
//                         </div>
//                       </div>
//                     )}

//                     {/* Upcoming Classes */}
//                     <div>
//                       <h3 className="text-xl font-semibold text-gray-800 mb-4">
//                         Upcoming Classes
//                       </h3>
//                       {liveClasses.filter((cls) => cls.status === "upcoming")
//                         .length === 0 ? (
//                         <div className="bg-gray-50 rounded-lg p-8 text-center">
//                           <h3 className="text-lg font-medium text-gray-900 mb-2">
//                             No upcoming classes
//                           </h3>
//                           <p className="text-gray-500">
//                             Check back later for new class schedules.
//                           </p>
//                         </div>
//                       ) : (
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                           {liveClasses
//                             .filter((cls) => cls.status === "upcoming")
//                             .map((upcomingClass) => (
//                               <div
//                                 key={upcomingClass.id}
//                                 className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
//                               >
//                                 <div className="relative h-48">
//                                   <img
//                                     src={
//                                       upcomingClass.image ||
//                                       "/images/placeholder.jpg"
//                                     }
//                                     alt={upcomingClass.title}
//                                     className="w-full h-full object-cover"
//                                   />
//                                   <div className="absolute top-0 right-0 m-2">
//                                     <span className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-0.5 rounded">
//                                       {upcomingClass.subject}
//                                     </span>
//                                   </div>
//                                 </div>
//                                 <div className="p-5">
//                                   <h3 className="text-lg font-bold text-gray-900 mb-2">
//                                     {upcomingClass.title}
//                                   </h3>
//                                   <p className="text-gray-600 mb-4 line-clamp-2">
//                                     {upcomingClass.description}
//                                   </p>
//                                   <div className="flex flex-wrap gap-3 mb-4">
//                                     <div className="flex items-center text-sm text-gray-700">
//                                       <svg
//                                         className="w-4 h-4 mr-1 text-gray-600"
//                                         fill="none"
//                                         stroke="currentColor"
//                                         viewBox="0 0 24 24"
//                                       >
//                                         <path
//                                           strokeLinecap="round"
//                                           strokeLinejoin="round"
//                                           strokeWidth={2}
//                                           d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a77 0 00-7 7h14a7 7 0 00-7-7z"
//                                         />
//                                       </svg>
//                                       {upcomingClass.instructor}
//                                     </div>
//                                     <div className="flex items-center text-sm text-gray-700">
//                                       <svg
//                                         className="w-4 h-4 mr-1 text-gray-600"
//                                         fill="none"
//                                         stroke="currentColor"
//                                         viewBox="0 0 24 24"
//                                       >
//                                         <path
//                                           strokeLinecap="round"
//                                           strokeLinejoin="round"
//                                           strokeWidth={2}
//                                           d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//                                         />
//                                       </svg>
//                                       {upcomingClass.date}
//                                     </div>
//                                     <div className="flex items-center text-sm text-gray-700">
//                                       <svg
//                                         className="w-4 h-4 mr-1 text-gray-600"
//                                         fill="none"
//                                         stroke="currentColor"
//                                         viewBox="0 0 24 24"
//                                       >
//                                         <path
//                                           strokeLinecap="round"
//                                           strokeLinejoin="round"
//                                           strokeWidth={2}
//                                           d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                                         />
//                                       </svg>
//                                       {upcomingClass.time}
//                                     </div>
//                                   </div>
//                                   <div className="flex justify-between items-center">
//                                     <Link
//                                       to={`/class-details/${upcomingClass.id}`}
//                                       className="text-indigo-600 hover:text-indigo-800 font-medium"
//                                     >
//                                       View Details
//                                     </Link>
//                                     {upcomingClass.isEnrolled ? (
//                                       <span className="text-green-600 text-sm font-medium">
//                                         Already Enrolled
//                                       </span>
//                                     ) : (
//                                       <button
//                                         onClick={() =>
//                                           handleEnroll(upcomingClass.id)
//                                         }
//                                         className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium"
//                                       >
//                                         <svg
//                                           className="w-4 h-4 mr-1"
//                                           fill="none"
//                                           stroke="currentColor"
//                                           viewBox="0 0 24 24"
//                                         >
//                                           <path
//                                             strokeLinecap="round"
//                                             strokeLinejoin="round"
//                                             strokeWidth={2}
//                                             d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                                           />
//                                         </svg>
//                                         Enroll Now
//                                       </button>
//                                     )}
//                                   </div>
//                                 </div>
//                               </div>
//                             ))}
//                         </div>
//                       )}
//                     </div>

//                     {/* Recent Completed Classes */}
//                     {/* {liveClasses.filter((cls) => cls.status === "completed")
//                       .length > 0 && (
//                       <div className="mt-12">
//                         <h3 className="text-xl font-semibold text-gray-800 mb-4">
//                           Recently Completed
//                         </h3>
//                         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//                           {liveClasses
//                             .filter((cls) => cls.status === "completed")
//                             .map((completedClass) => (
//                               <div
//                                 key={completedClass.id}
//                                 className="bg-white border border-gray-200 rounded-lg shadow overflow-hidden"
//                               >
//                                 <div className="relative h-36">
//                                   <img
//                                     src={
//                                       completedClass.image ||
//                                       "/images/placeholder.jpg"
//                                     }
//                                     alt={completedClass.title}
//                                     className="w-full h-full object-cover filter brightness-75"
//                                   />
//                                   <div className="absolute inset-0 flex items-center justify-center">
//                                     <span className="bg-gray-900 bg-opacity-60 text-white px-3 py-1 rounded-full text-sm">
//                                       Completed on {completedClass.date}
//                                     </span>
//                                   </div>
//                                 </div>
//                                 <div className="p-4">
//                                   <div className="flex justify-between items-start mb-2">
//                                     <h3 className="text-md font-bold text-gray-900 line-clamp-1">
//                                       {completedClass.title}
//                                     </h3>
//                                     <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2 py-0.5 rounded">
//                                       {completedClass.subject}
//                                     </span>
//                                   </div>
//                                   <div className="flex items-center text-xs text-gray-700 mb-3">
//                                     <svg
//                                       className="w-3.5 h-3.5 mr-1 text-gray-600"
//                                       fill="none"
//                                       stroke="currentColor"
//                                       viewBox="0 0 24 24"
//                                     >
//                                       <path
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         strokeWidth={2}
//                                         d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                                       />
//                                     </svg>
//                                     {completedClass.instructor}
//                                   </div>
//                                   <Link
//                                     to="/recorded-classes"
//                                     className="text-indigo-600 hover:text-indigo-800 text-sm font-medium"
//                                   >
//                                     Watch Recording
//                                   </Link>
//                                 </div>
//                               </div>
//                             ))}
//                         </div>
//                       </div>
//                     )} */}
//                   </>
//                 )}
//               </div>

//               {/* Class Calendar Section - same as before */}
//             </div>
//           )}

//           {/* Recorded Classes Tab Content - UPDATED */}
//           {activeTab === "recorded" && (
//             <div>
//               <div className="mb-12">
//                 <h2 className="text-3xl font-bold text-gray-900 mb-6">
//                   Recorded Sessions Library
//                 </h2>
//                 <p className="text-lg text-gray-600 mb-8">
//                   Access our extensive library of recorded sessions. Study at
//                   your own pace, revisit important concepts, and strengthen your
//                   NPSC preparation.
//                 </p>

//                 {/* Filters */}
//                 <div className="bg-gray-50 p-6 rounded-lg mb-8">
//                   <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                     <div>
//                       <label
//                         htmlFor="subject-filter"
//                         className="block text-sm font-medium text-gray-700 mb-1"
//                       >
//                         Filter by Subject
//                       </label>
//                       <select
//                         id="subject-filter"
//                         className="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
//                         value={subjectFilter}
//                         onChange={(e) => setSubjectFilter(e.target.value)}
//                       >
//                         <option value="all">All Subjects</option>
//                         {subjects.map((subject) => (
//                           <option key={subject} value={subject}>
//                             {subject}
//                           </option>
//                         ))}
//                       </select>
//                     </div>

//                     <div>
//                       <label
//                         htmlFor="search-filter"
//                         className="block text-sm font-medium text-gray-700 mb-1"
//                       >
//                         Search
//                       </label>
//                       <div className="relative">
//                         <input
//                           type="text"
//                           id="search-filter"
//                           className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 pl-10"
//                           placeholder="Search by title, instructor, or topic"
//                           value={searchQuery}
//                           onChange={(e) => setSearchQuery(e.target.value)}
//                         />
//                         <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
//                           <svg
//                             className="w-5 h-5 text-gray-400"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth={2}
//                               d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                             />
//                           </svg>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Recorded Sessions Grid */}
//                 {loading ? (
//                   <div className="flex justify-center items-center py-20">
//                     <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
//                   </div>
//                 ) : error ? (
//                   <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
//                     {error}
//                   </div>
//                 ) : recordedSessions.length === 0 ? (
//                   <div className="text-center py-10">
//                     <svg
//                       className="w-16 h-16 text-gray-300 mx-auto mb-4"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
//                       />
//                     </svg>
//                     <h3 className="text-lg font-medium text-gray-900 mb-1">
//                       No sessions found
//                     </h3>
//                     <p className="text-gray-600">
//                       Try adjusting your search or filter criteria
//                     </p>
//                   </div>
//                 ) : (
//                   <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                     {recordedSessions.map((session) => (
//                       <motion.div
//                         key={session._id}
//                         initial={{ opacity: 0, y: 20 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         transition={{ duration: 0.3 }}
//                         className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300"
//                       >
//                         <div className="relative">
//                           <img
//                             src={session.image || "/images/placeholder.jpg"}
//                             alt={session.title}
//                             className="w-full h-48 object-cover"
//                           />
//                           <div className="absolute inset-0 flex items-center justify-center">
//                             <div className="w-14 h-14 bg-white/80 rounded-full flex items-center justify-center">
//                               <svg
//                                 className="w-8 h-8 text-indigo-600"
//                                 fill="currentColor"
//                                 viewBox="0 0 20 20"
//                               >
//                                 <path d="M4 5h3v10H4V5zm12 0v10l-9-5 9-5z" />
//                               </svg>
//                             </div>
//                           </div>
//                           <div className="absolute top-2 right-2 flex space-x-2">
//                             <span className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-0.5 rounded">
//                               {session.subject}
//                             </span>
//                             <span
//                               className={`text-xs font-medium px-2.5 py-0.5 rounded ${
//                                 session.type === "foundation"
//                                   ? "bg-green-100 text-green-800"
//                                   : session.type === "prelims"
//                                   ? "bg-blue-100 text-blue-800"
//                                   : "bg-purple-100 text-purple-800"
//                               }`}
//                             >
//                               {session.type.charAt(0).toUpperCase() +
//                                 session.type.slice(1)}
//                             </span>
//                           </div>
//                           <div className="absolute bottom-2 left-2 bg-black/60 text-white text-xs font-medium px-2.5 py-0.5 rounded">
//                             {session.duration}
//                           </div>
//                         </div>
//                         <div className="p-5">
//                           <h3 className="text-lg font-bold text-gray-900 mb-2">
//                             {session.title}
//                           </h3>
//                           <p className="text-gray-600 text-sm mb-4 line-clamp-2">
//                             {session.description}
//                           </p>
//                           <div className="flex items-center mb-4">
//                             <svg
//                               className="w-4 h-4 mr-1 text-gray-600"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                               />
//                             </svg>
//                             <p className="text-sm text-gray-700">
//                               {session.instructor}
//                             </p>
//                           </div>
//                           <div className="flex justify-between items-center">
//                             <span className="text-xs text-gray-500">
//                               Added on{" "}
//                               {new Date(session.date).toLocaleDateString(
//                                 "en-US",
//                                 {
//                                   month: "long",
//                                   day: "numeric",
//                                   year: "numeric",
//                                 }
//                               )}
//                             </span>
//                             <Link
//                               to={`/watch-session/${session._id}`}
//                               className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium"
//                             >
//                               <span>Watch</span>
//                               <svg
//                                 className="w-4 h-4 ml-1"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 viewBox="0 0 24 24"
//                               >
//                                 <path
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                   strokeWidth={2}
//                                   d="M17 8l4 4m0 0l-4 4m4-4H3"
//                                 />
//                               </svg>
//                             </Link>
//                           </div>
//                         </div>
//                       </motion.div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>
//       </section>
//     </div>
//   );
// };

// export default OnlineClassesPage;
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { CONSTANTS } from "../constants/Constants";
import { useEnrollment } from "../context/EnrollmentContext";
import LockedSection from "../components/LockedSection";
import RecordedClassesSection from "./RecordedClassesSection";

const OnlineClassesPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // State for active tab
  const [activeTab, setActiveTab] = useState("live");
  const { activeEnrollments, loading: enrollmentLoading } = useEnrollment();

  // State for API data
  const [liveClasses, setLiveClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCourseId, setSelectedCourseId] = useState("all");
  const [selectedLanguage, setSelectedLanguage] = useState("all");
  const [selectedClass, setSelectedClass] = useState("10th");

  // Handler for enrollment card selection
  const handleEnrollmentSelect = (enrollment) => {
    setSelectedCourseId(enrollment.courseId);
    setSelectedLanguage(enrollment.language?.toLowerCase() || "all");

    // Extract class from course name
    const className = enrollment.courseName.includes("10th")
      ? "10th"
      : enrollment.courseName.includes("9th")
      ? "9th"
      : enrollment.courseName.includes("8th")
      ? "8th"
      : "all";
    setSelectedClass(className);
  };

  // Set first enrollment as default when enrollments load
  useEffect(() => {
    if (activeEnrollments && activeEnrollments?.length > 0) {
      handleEnrollmentSelect(activeEnrollments[0]);
    }
  }, [activeEnrollments]);

  // Fetch live classes from API
  useEffect(() => {
    const fetchLiveClasses = async () => {
      try {
        setLoading(true);

        // Get all classes (no authentication required)
        const response = await axios.get(
          `${CONSTANTS.APIURL}/api/scheduled-classesnew/public`
        );
        const classes = response.data || [];

        // Transform the data
        const formattedClasses = classes.map((cls) => ({
          id: cls._id,
          title: cls.title,
          instructor: cls.instructor?.name || "Unknown Instructor",
          date: formatDate(cls.scheduledStartTime),
          time: `${formatTime(cls.scheduledStartTime)} - ${formatTime(
            cls.scheduledEndTime
          )}`,
          subject: cls.category || "General",
          description: cls.description,
          image:
            cls.thumbnail ||
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRCjwItGdnaofbsuvTl7O9aJxfCBaZd-ms0lw&s",
          joinLink: `/live-class/${cls._id}/join`,
          status: getClassStatus(cls),
          isEnrolled: true,
          meetingId: cls.meetingId,
          rawData: cls,
        }));

        setLiveClasses(formattedClasses);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching live classes:", err);
        setError("Failed to load classes. Please try again later.");
        setLoading(false);
        setLiveClasses([]);
      }
    };

    fetchLiveClasses();
  }, []);

  // Helper function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();

    if (date.toDateString() === today.toDateString()) {
      return "Today";
    }

    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  // Helper function to format time
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  // Helper function to determine class status
  const getClassStatus = (cls) => {
    if (cls.status === "live") {
      return "live";
    }

    const now = new Date();
    const startTime = new Date(cls.scheduledStartTime);
    const endTime = new Date(cls.scheduledEndTime);

    if (now < startTime) {
      return "upcoming";
    } else if (now > endTime || cls.status === "completed") {
      return "completed";
    } else {
      return "live";
    }
  };

  // Handle class enrollment
  const handleEnroll = async (classId) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      await axios.post(
        `${CONSTANTS.APIURL}/api/scheduled-classes/${classId}/enroll`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": token,
          },
        }
      );

      // Update class in state to show as enrolled
      setLiveClasses((prevClasses) =>
        prevClasses.map((cls) =>
          cls.id === classId ? { ...cls, isEnrolled: true } : cls
        )
      );

      setLoading(false);
      alert("Successfully enrolled in class!");
    } catch (err) {
      console.error("Error enrolling in class:", err);
      setLoading(false);
      alert("Failed to enroll in class. Please try again.");
    }
  };

  // Handle joining a class
  const handleJoinClass = (classItem) => {
    if (classItem.status === "live") {
      navigate(`/live-class/${classItem.id}/join`);
    } else if (classItem.status === "upcoming") {
      alert(
        "This class hasn't started yet. Please check back at the scheduled time."
      );
    } else {
      alert(
        "This class has ended. You can find the recording in the Recorded Classes section."
      );
    }
  };

  // Show locked section if no enrollments
  if (activeEnrollments?.length === 0) {
    return <LockedSection />;
  }

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative bg-gray-900 text-white">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gray-900 opacity-90"></div>
          <div className="absolute inset-0 bg-[url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRiqn5jXhC1CTq8isbIwTTte77VL0U7zhlBwQ&s')] opacity-10 bg-cover bg-center"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="grid lg:grid-cols-12 gap-8 items-center">
            {/* Left Content */}
            <div className="lg:col-span-7">
              <motion.h1
                className="text-4xl md:text-5xl font-extrabold tracking-tight mb-6"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                Excellence in Education
              </motion.h1>
              <motion.p
                className="text-lg md:text-xl mb-8 text-gray-200"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                Empowering students with comprehensive education for academic
                excellence and competitive exam success. Learn from top
                educators and subject matter experts from anywhere, anytime.
              </motion.p>
              <motion.div
                className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <Link
                  to="/classroom"
                  className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-indigo-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
                >
                  Subscribe Now
                </Link>
                <Link
                  to="/watch-session/683ef9a271bed98aea1797e6"
                  className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
                >
                  Try Free Class
                </Link>
              </motion.div>
            </div>

            {/* Right Content - Enrollment Cards */}
            <div className="lg:col-span-5">
              <motion.div
                className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <h3 className="text-xl font-semibold mb-6 text-yellow-400">
                  Your Active Courses
                </h3>

                <div className="space-y-3 max-h-96 overflow-y-auto custom-scrollbar">
                  {activeEnrollments.map((enrollment, index) => (
                    <motion.div
                      key={enrollment.courseId}
                      onClick={() => handleEnrollmentSelect(enrollment)}
                      className={`cursor-pointer border rounded-xl p-4 transition-all duration-200 hover:scale-[1.02] ${
                        selectedCourseId === enrollment.courseId
                          ? "border-yellow-400 bg-yellow-400/10"
                          : "border-white/20 hover:border-white/40 bg-white/5"
                      }`}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.4, delay: 0.4 + index * 0.1 }}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex-1 min-w-0">
                          <h4 className="font-medium text-white text-sm truncate mb-2">
                            {enrollment.courseName}
                          </h4>
                          <div className="space-y-1">
                            <div className="flex items-center text-xs text-gray-300">
                              <svg
                                className="w-3 h-3 mr-1"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                                />
                              </svg>
                              {enrollment.language}
                            </div>
                            <div className="flex items-center justify-between">
                              <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-500/20 text-green-300 border border-green-500/30">
                                Active
                              </span>
                              <span className="text-xs text-gray-400">
                                Expires:{" "}
                                {enrollment.expiryDate.toLocaleDateString(
                                  "en-US",
                                  {
                                    month: "short",
                                    day: "numeric",
                                  }
                                )}
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Selection indicator */}
                        <div
                          className={`ml-3 w-5 h-5 rounded-full border-2 transition-all duration-200 flex items-center justify-center ${
                            selectedCourseId === enrollment.courseId
                              ? "bg-yellow-400 border-yellow-400"
                              : "border-white/40"
                          }`}
                        >
                          {selectedCourseId === enrollment.courseId && (
                            <svg
                              className="w-3 h-3 text-gray-900"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clipRule="evenodd"
                              />
                            </svg>
                          )}
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>

                {/* No enrollments state */}
                {activeEnrollments.length === 0 && (
                  <div className="text-center py-8">
                    <svg
                      className="w-12 h-12 text-gray-400 mx-auto mb-3"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1}
                        d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                      />
                    </svg>
                    <p className="text-sm text-gray-400">
                      No active enrollments
                    </p>
                  </div>
                )}
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Tabs */}
          <div className="border-b border-gray-200 mb-8">
            <div className="flex space-x-8">
              <button
                className={`pb-4 text-lg font-medium transition-colors duration-200 ${
                  activeTab === "live"
                    ? "border-b-2 border-indigo-600 text-indigo-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
                onClick={() => setActiveTab("live")}
              >
                <span className="flex items-center">
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                  Live Classes
                </span>
              </button>
              <button
                className={`pb-4 text-lg font-medium transition-colors duration-200 ${
                  activeTab === "recorded"
                    ? "border-b-2 border-indigo-600 text-indigo-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
                onClick={() => setActiveTab("recorded")}
              >
                <span className="flex items-center">
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                  Recorded Classes
                </span>
              </button>
            </div>
          </div>

          {/* Live Classes Tab Content */}
          {activeTab === "live" && (
            <div>
              <div className="mb-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Upcoming & Live Classes
                </h2>
                <p className="text-lg text-gray-600 mb-8">
                  Join our expert instructors in real-time interactive sessions.
                  Participate in discussions, ask questions, and get instant
                  clarification on complex topics.
                </p>

                {loading ? (
                  <div className="flex justify-center items-center py-20">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
                  </div>
                ) : error ? (
                  <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                    {error}
                  </div>
                ) : (
                  <>
                    {/* Currently Live Classes */}
                    {liveClasses.filter((cls) => cls.status === "live").length > 0 && (
                      <div className="mb-12">
                        <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                          <span className="relative flex h-3 w-3 mr-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                          </span>
                          Currently Live
                        </h3>
                        <div className="grid grid-cols-1 gap-6">
                          {liveClasses
                            .filter((cls) => cls.status === "live")
                            .map((liveClass) => (
                              <div
                                key={liveClass.id}
                                className="bg-gradient-to-r from-indigo-50 to-blue-50 border border-indigo-100 rounded-lg shadow-md overflow-hidden"
                              >
                                <div className="flex flex-col md:flex-row">
                                  <div className="md:w-1/3 bg-gray-200 h-60 md:h-auto">
                                    <img
                                      src={liveClass.image || "/images/placeholder.jpg"}
                                      alt={liveClass.title}
                                      className="w-full h-full object-cover"
                                    />
                                  </div>
                                  <div className="p-6 md:w-2/3 flex flex-col justify-between">
                                    <div>
                                      <div className="flex justify-between items-start">
                                        <div>
                                          <span className="inline-block bg-red-100 text-red-800 text-xs font-semibold px-2.5 py-0.5 rounded-md mb-2">
                                            LIVE NOW
                                          </span>
                                          <h3 className="text-xl font-bold text-gray-900 mb-2">
                                            {liveClass.title}
                                          </h3>
                                        </div>
                                        <span className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-0.5 rounded">
                                          {liveClass.subject}
                                        </span>
                                      </div>
                                      <p className="text-gray-600 mb-4">
                                        {liveClass.description}
                                      </p>
                                      <div className="flex flex-wrap gap-3 mb-4">
                                        <div className="flex items-center text-sm text-gray-700">
                                          <svg className="w-4 h-4 mr-1 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                          </svg>
                                          {liveClass.instructor}
                                        </div>
                                        <div className="flex items-center text-sm text-gray-700">
                                          <svg className="w-4 h-4 mr-1 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                          </svg>
                                          {liveClass.time}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="mt-4">
                                      {liveClass.isEnrolled ? (
                                        <button
                                          onClick={() => handleJoinClass(liveClass)}
                                          className="inline-flex items-center justify-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-md transition-colors duration-300"
                                        >
                                          Join Now
                                        </button>
                                      ) : (
                                        <button
                                          onClick={() => handleEnroll(liveClass.id)}
                                          className="inline-flex items-center justify-center px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-md transition-colors duration-300"
                                        >
                                          Enroll & Join
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    )}

                    {/* Upcoming Classes */}
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-4">
                        Upcoming Classes
                      </h3>
                      {liveClasses.filter((cls) => cls.status === "upcoming").length === 0 ? (
                        <div className="bg-gray-50 rounded-lg p-8 text-center">
                          <svg className="w-12 h-12 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                          <h3 className="text-lg font-medium text-gray-900 mb-2">
                            No upcoming classes
                          </h3>
                          <p className="text-gray-500">
                            Check back later for new class schedules.
                          </p>
                        </div>
                      ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          {liveClasses
                            .filter((cls) => cls.status === "upcoming")
                            .map((upcomingClass) => (
                              <div
                                key={upcomingClass.id}
                                className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
                              >
                                <div className="relative h-48">
                                  <img
                                    src={upcomingClass.image || "/images/placeholder.jpg"}
                                    alt={upcomingClass.title}
                                    className="w-full h-full object-cover"
                                  />
                                  <div className="absolute top-0 right-0 m-2">
                                    <span className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-0.5 rounded">
                                      {upcomingClass.subject}
                                    </span>
                                  </div>
                                </div>
                                <div className="p-5">
                                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                                    {upcomingClass.title}
                                  </h3>
                                  <p className="text-gray-600 mb-4 line-clamp-2">
                                    {upcomingClass.description}
                                  </p>
                                  <div className="flex flex-wrap gap-3 mb-4">
                                    <div className="flex items-center text-sm text-gray-700">
                                      <svg className="w-4 h-4 mr-1 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                      </svg>
                                      {upcomingClass.instructor}
                                    </div>
                                    <div className="flex items-center text-sm text-gray-700">
                                      <svg className="w-4 h-4 mr-1 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                      </svg>
                                      {upcomingClass.date}
                                    </div>
                                    <div className="flex items-center text-sm text-gray-700">
                                      <svg className="w-4 h-4 mr-1 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                      </svg>
                                      {upcomingClass.time}
                                    </div>
                                  </div>
                                  <div className="flex justify-between items-center">
                                    <Link
                                      to={`/class-details/${upcomingClass.id}`}
                                      className="text-indigo-600 hover:text-indigo-800 font-medium"
                                    >
                                      View Details
                                    </Link>
                                    {upcomingClass.isEnrolled ? (
                                      <span className="text-green-600 text-sm font-medium">
                                        Already Enrolled
                                      </span>
                                    ) : (
                                      <button
                                        onClick={() => handleEnroll(upcomingClass.id)}
                                        className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium"
                                      >
                                        <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                        </svg>
                                        Enroll Now
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {/* Recorded Classes Tab Content */}
          {activeTab === "recorded" && (
            <RecordedClassesSection
              selectedCourseId={selectedCourseId}
              selectedLanguage={selectedLanguage}
              selectedClass={selectedClass}
            />
          )}
        </div>
      </section>

      {/* Quick Stats Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Why Choose Our Online Classes?
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Experience world-class education with our comprehensive online learning platform
              designed specifically for competitive exam preparation.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <motion.div
              className="text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="bg-indigo-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">500+</h3>
              <p className="text-gray-600">Recorded Sessions</p>
            </motion.div>

            <motion.div
              className="text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">50+</h3>
              <p className="text-gray-600">Expert Instructors</p>
            </motion.div>

            <motion.div
              className="text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="bg-yellow-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">24/7</h3>
              <p className="text-gray-600">Access Anytime</p>
            </motion.div>

            <motion.div
              className="text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">95%</h3>
              <p className="text-gray-600">Success Rate</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Comprehensive Learning Experience
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Our platform offers everything you need for successful exam preparation
              with cutting-edge technology and proven teaching methodologies.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <motion.div
              className="bg-gradient-to-br from-indigo-50 to-blue-50 p-6 rounded-xl border border-indigo-100"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="bg-indigo-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Interactive Live Classes</h3>
              <p className="text-gray-600 mb-4">
                Join real-time interactive sessions with expert faculty. Ask questions,
                participate in discussions, and get instant clarifications.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  HD Video Quality
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Screen Sharing & Whiteboard
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Live Chat & Q&A
                </li>
              </ul>
            </motion.div>

            <motion.div
              className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-xl border border-green-100"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <div className="bg-green-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Extensive Video Library</h3>
              <p className="text-gray-600 mb-4">
                Access hundreds of recorded sessions organized by chapters and topics.
                Study at your own pace with our comprehensive video library.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Chapter-wise Organization
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Multiple Playback Speeds
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Offline Download Option
                </li>
              </ul>
            </motion.div>

            <motion.div
              className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-xl border border-purple-100"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="bg-purple-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Progress Tracking</h3>
              <p className="text-gray-600 mb-4">
                Monitor your learning progress with detailed analytics and performance insights.
                Track completed sessions and identify areas for improvement.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Detailed Analytics
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Performance Reports
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Personalized Recommendations
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-indigo-600 to-purple-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Ready to Excel in Your Exams?
            </h2>
            <p className="text-xl text-indigo-100 mb-8 max-w-3xl mx-auto">
              Join thousands of successful students who have achieved their goals with our
              comprehensive online learning platform. Start your journey today!
            </p>
            {/* <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/subscribe"
                className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-white hover:bg-gray-50 transition-colors duration-300 shadow-lg"
              >
                Get Started Now
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
              <Link
                to="/free-trial"
                className="inline-flex items-center justify-center px-8 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
              >
                Try Free Class
              </Link>
            </div> */}
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default OnlineClassesPage;